import { Component, ViewEncapsulation, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { ConciergeApiService } from 'src/shared/services/concierge-api.service';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Logger } from 'src/providers/logger';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Util } from 'src/shared/util/util';

import { ConciergeItemModel } from 'src/models/concierge.model';

@Component({
    templateUrl: 'dispute-resolution.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class DisputeResolutionPage implements OnInit {

  isRightSideContent: boolean;
  email: string;
  errorMessage: string;
  dispute: ConciergeItemModel;
  replyTime: string;
  status: string;
  createdAt: Date;
  jobData: any;
  isJobIssue: boolean;
  loaded: boolean;
  backPage = 'notification-center';
  showActionButtons = false;
  isPendingResponse = false;

  private readonly actionableDisputeTypes = [
    'dispute.customer_dispute_counter_answer',
    'dispute.cleaning.customer.counter_proposal',
    'dispute.cleaning.customer.opened',
  ];

  private readonly pendingDisputeTypes = [
    'dispute.customer_dispute_initiated',
  ];

  private readonly rightSidePanelService = inject(RightSidePanelService);
  private readonly conciergeApi = inject(ConciergeApiService);
  private readonly logger = inject(Logger);
  private readonly navCtrl = inject(CustomNavController);
  private readonly route = inject(ActivatedRoute);
  private readonly storage = inject(TidyStorage);
  private readonly util = inject(Util);

  constructor() {}

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.loadDataAndParams();
  }

  async loadDataAndParams() {
    this.loaded = false;
    const dialogParams = await this.storage.retrieve('dialog-params');
    this.dispute = dialogParams?.dispute || this.navCtrl.getParam('dispute');
    this.backPage = dialogParams?.backPage || this.navCtrl.getParam('backPage') || 'notification-center';
    this.rightSidePanelService.setDialogPageTitle(this.dispute?.header_text || 'Dispute Resolution');
    try {
      if (!this.dispute) {
        const disputeItemId = parseInt(this.route.snapshot.paramMap.get('disputeItemId'));
        this.dispute = await lastValueFrom(this.conciergeApi.getConciergeItemById(disputeItemId));
      }
      this.showActionButtons = this.actionableDisputeTypes.includes(this.dispute?.type);
      this.isPendingResponse = this.pendingDisputeTypes.includes(this.dispute?.type);
      this.loaded = true;
    } catch (err) {
      if (err) {
        this.logger.error(err);
        this.errorMessage = err?.error?.message ?? err?.message;
      }
    }
  }

  async replyCounter(action) {
    const data = {
      concierge_item_id: this.dispute.id,
      action_name: action,
      params: {
        concierge_item_id: this.dispute.id,
        concierge_item_type_component_id: this.dispute.components[0].id,
        customer_cleaning_dispute_id: this.dispute.metadata?.customer_cleaning_dispute_id
      }
    }
    try {
      await lastValueFrom(this.conciergeApi.replyDisputeCounter(this.dispute.id, data));
      this.util.showSuccess('Your response has been submitted.');
      this.rightSidePanelService.navigateTo(this.backPage);
    } catch (err) {
      this.logger.error(err);
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

}
